import _ from "lodash";
import abtest from 'common/abtest';
import Utils from 'common/Utils';
import log from 'common/Logger';
import {getCreatedDateEpoch, getLastLoginDateEpoch, getUserId, getUser, getUserRole, getUserSettings,getUserEmail} from "../common/UserService";
import {getHubspotIdentityToken, updateHubspotClient} from "../common/api";
import feature_flags from "../common/feature_flags";

let extra_attribs = {};
let loaded = false;

function onConversationsAPIReady() {
    log.debug(`HubSpot Conversations API:`, window.HubSpotConversations);
}

export async function loadHubspotTracking() {
    if (Utils.getUrlParamByName('hubspot') || feature_flags.isActive('hubspot_chat')) {
        window._hsq = window._hsq || [];
        window.hsConversationsSettings = {
            loadImmediately: false,
        };
        /*
         If external API methods are already available, use them.
        */
        if (window.HubSpotConversations) {
            onConversationsAPIReady();
        } else {
            /*
              Otherwise, callbacks can be added to the hsConversationsOnReady on the window object.
              These callbacks will be called once the external API has been initialized.
            */
            window.hsConversationsOnReady = [onConversationsAPIReady];
        }
        //load script
        const src = 'https://js.hs-scripts.com/49720122.js';
        await Utils.loadScript(src, true, {defer: true, type: 'text/javascript'}, 'hs-script-loader');
        try {
            const success = await identifyHubspotUser();
            if (success) {
                window.hideCustomerly = true;
                window.HubSpotConversations.widget.load();
                window.customerly.hide();
            } else {
                log.error('HubSpot user identification failed - fallback to customerly');
            }
        }
        catch (e) {
            log.error('HubSpot user identification failed - fallback to customerly', e);
        }

    }

}

export async function identifyHubspotUser() {
    try {
        const user = getUser()
        if (user) {
            const email = user.email;
            let token = null;
            if (email) {
                const data = await getHubspotIdentityToken()
                if (data.success) {
                    token = data.token;
                } else {
                    log.debug('HubSpot token did not return');
                }
            }
            if (token) {
                if (window.hsConversationsSettings) {
                    window.hsConversationsSettings.identificationEmail = email;
                    window.hsConversationsSettings.identificationToken = token;
                    return true
                }
                else {
                    log.debug('identifyHubspotUser() -> HubSpot not initialized - skipping.');
                    return false
                }
            }
        }
    } catch (error) {
        log.error('Error identifying HubSpot user:', error);
    }
}

export function reportHubspotCustomEvent(eventName, properties = {}) {
    try {
        if (window._hsq) {
            window._hsq.push(
                ['trackCustomBehavioralEvent', eventName, properties]
            );
        } else {
            log.debug('reportCustomEvent -> HubSpot not initialized - skipping.');
        }
    } catch (error) {
        log.error('Error reporting HubSpot event:', error);
    }
}

export function trackHubspotPageView(path) {
    try {
        if (window._hsq) {
            window._hsq.push(['setPath', path]);
            window._hsq.push(['trackPageView']);
        } else {
            log.debug('trackHubspotPageView -> HubSpot not initialized - skipping.');
        }
    } catch (error) {
        log.error('Error reporting HubSpot page view:', error);
    }
}


export function loadHubspot() {
    const user = getUser()
    window.hubspotSettings = {
        email: user.email,
        attributes: {
            'user_id': getUserId(),
            'role': getUserRole(),
            'firstname': _.capitalize(user.firstName),
            'lastname': _.capitalize(user.lastName),
            'username': user.username,
            'fullname': Utils.getFullname(user),
            'last_login_date': getLastLoginDateEpoch(),
            'create_date': getCreatedDateEpoch(),
            'ab_test': abtest.abTestId,
            'ab_test_var': abtest.uid,
            ...extra_attribs,
        }
    };
    const userSettings = getUserSettings();
    if (!_.isEmpty(userSettings)) {
        if (!_.isEmpty(userSettings.subscription)) {
            window.hubspotSettings.attributes.sub_active = _.result(userSettings, 'subscription.active', false);
            window.hubspotSettings.attributes.sub_id = _.result(userSettings, 'subscription.sub_id', '');
            window.hubspotSettings.attributes.sub_created_at = _.result(userSettings, 'subscription.start_date', '');
            window.hubspotSettings.attributes.sub_status = _.result(userSettings, 'subscription.status', '');
        }
        if (userSettings.school_name) {
            window.hubspotSettings.attributes.school_name = userSettings.school_name;
        }
        if (userSettings.job_title) {
            window.hubspotSettings.attributes.job_title = userSettings.job_title;
        }
        if (userSettings.ref) {
            window.hubspotSettings.attributes.ref = userSettings.ref;
        }
    }
    updateHubspot(window.hubspotSettings.attributes);
    loaded = true;
}

export function updateHubspot(settings = {}) {
    try {
        extra_attribs = _.assign(extra_attribs, settings);
        if (window.hubspotSettings) {
            try {
                log.debug('updating hubspot', settings);
                window.hubspotSettings.attributes = extra_attribs;
                let email = window.hubspotSettings.email;
                if (!email || email === 'undefined' || email === 'null' || email === '') {
                    email = getUserEmail();
                    if (!email || email === 'undefined' || email === 'null' || email === '') {
                        log.always('No email found for HubSpot settings');
                        return;
                    }
                    window.hubspotSettings.email = email
                }
                updateHubspotClient(extra_attribs);
            } catch (error) {
                log.error('Error updating HubSpot settings:', error);
            }
        } else {
            log.warn('hubspotSettings not initialized');
        }
    } catch (error) {
        log.error('Error in updateHubspot:', error);
    }
}

export function loadHubspotForLeads() {
    if (loaded) return;
    updateHubspot(window.hubspotSettings.attributes)
}
